import { Component, computed, inject, input } from '@angular/core';
import { Router } from '@angular/router';
import { ContractorCitationListDto } from '@umss/shared/data-access';
import { UmssButtonComponent } from '../button/button.component';
import { UmssCardComponent } from '../card/card.component';
import { UmssIconComponent } from '../icon/icon.component';

@Component({
  selector: 'umss-citations-alert',
  imports: [UmssCardComponent, UmssIconComponent, UmssButtonComponent],
  templateUrl: './citations-alert.component.html',
  styleUrl: './citations-alert.component.scss'
})
export class CitationsAlertComponent {
  router = inject(Router);
  openedCitations = input<ContractorCitationListDto[]>([]);
  count = input<number | undefined>(undefined);
  showRedirectButton = input(true);

  readonly effectiveCount = computed(
    () => this.count() ?? this.openedCitations().length
  );

  onClickExpandDetails(): void {
    this.router.navigate(['/profile'], { fragment: 'citations-section' });
  }
}
